import styled from 'styled-components'

export const DataTableWrapper = styled.div`
  & .ant-checkbox-wrapper.hidden {
    display: none;
  }
  
  & .ant-table-cell.small {
    width: 100px;
  }
  
  & .ant-table-cell.medium {
    width: 150px;
  }
`
